<template>
  <div class="flex items-center gap-4">
    <div v-if="!hideThumbnail">
      <Link :href="route(link.name, value?.slug ? value?.slug: '')"
        v-if="!subTable"
        class="flex items-center justify-center"
        :class="{
          'w-24 p-3 rounded-md': density === 'default',
          'w-16 p-1 rounded-sm': density === 'compact',
          'w-8 p-0.5 rounded-sm': density === 'dense',
        }"
        tabindex="-1">
        <img
          v-if="productCardImage(value)"
          class="mx-auto max-w-full object-contain"
          :src="productCardImage(value)"
          :alt="value.display_sku"
          :class="{
            'min-h-20 max-h-24': density === 'default',
            'min-h-12 max-h-12': density === 'compact',
            'min-h-8 max-h-8': density === 'dense',
          }">
        <BaseSvg
          v-else
          name="icon-product-empty"
          class="rounded p-2 mx-auto max-w-[10rem] object-contain bg-black fill-gray"
          :class="{
            'max-h-24 p-2': density === 'default',
            'max-h-12 p-2': density === 'compact',
            'max-h-8': density === 'dense',
          }" />
      </Link>
      <div v-else>
        <div
          class="border-keyline-primary border-l border-b rounded-bl-sm"
          :class="{
            'pt-4 pr-6': density === 'default',
            'pt-2 pr-8': density === 'compact',
            'pt-2 pr-10': density === 'dense',
          }" />
      </div>
    </div>
    <div class="w-auto at1024:max-w-lg at1350:max-w-xl">
      <div v-if="link.name" class="flex items-center gap-2">
        <Link
          v-if="value?.slug"
          :href="route(link.name, value?.slug ? value?.slug: '')"
          class="text-base type-primary font-medium hover:underline underline-offset-4 decoration-dotted">
          {{ value.display_sku ?? value.name ?? value.item_id }}
        </Link>
        <button
          v-if="preview"
          class="opacity-0 group-hover:opacity-50 active:!opacity-100"
          @click="eventBus.emit('dialog:toggle-product-preview', {
            event: $event,
            data: {card: value},
            sourcing: settings.is_sourcing_mode,
          })">
          <BaseSvg
            class="w-5 h-5"
            name="icon-preview" />
        </button>
      </div>
      <span v-else class="text-base type-primary font-bold">{{ value.display_sku ?? value.name }}</span>
      <div
        v-if="value.display_short_description && density !== 'dense'"
        class="text-sm type-secondary whitespace-normal line-clamp-3">
        {{ value.display_short_description }}
      </div>
      <div
        v-else-if="value.description && density !== 'dense'"
        class="text-sm type-secondary whitespace-normal line-clamp-3">
        {{ value.description }}
      </div>
    </div>
  </div>
</template>

<script setup>
//accepts a card
import {useAssetTransforms, useUser, eventBus} from "@/Composables";
import {BaseSvg} from "@/Components";
import {Link} from "@inertiajs/vue3";
import {computed} from "vue";

const { settings } = useUser();
const { productCardImage } = useAssetTransforms();

const props = defineProps(['value','column','link','preview','subTable', 'hideThumbnail', 'wrapText']);
const density = computed(() =>  settings.value.is_sourcing_mode ? settings.value.density : 'default');
</script>
